import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Select } from 'antd';
import { selectors, actions } from '../../../model';
import { uploadingFieldNames } from '../../../config/uploadingStep';
import FormItem from '../../ui/FormItem/FormItem';

const { selectUploadingStepValue, selectUploadingStepError } = selectors;
const { sheetChangeAction } = actions;

const fieldName = uploadingFieldNames.sheet;

const valueSelector = (state) => selectUploadingStepValue(state, fieldName);
const errorSelector = (state) => selectUploadingStepError(state, fieldName);

const SelectSheetName = ({ sheetNames }) => {
  const value = useSelector(valueSelector);
  const errors = useSelector(errorSelector);

  const dispatch = useDispatch();

  const handleChange = (value) => dispatch(sheetChangeAction(value));

  return (
    <FormItem
      required
      label="Страница файла"
      errors={errors}
    >
      <Select
        value={value}
        style={{ width: '100%' }}
        onChange={handleChange}
        placeholder="Выберите страницу файла"
      >
        {sheetNames.map((sheetName) => (
          <Select.Option
            value={sheetName}
            key={sheetName}
          >
            {sheetName}
          </Select.Option>
        ))}
      </Select>
    </FormItem>
  );
};

export default SelectSheetName;
